import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import App from "./App";
import { ContextProvider } from "./contexts/ContextProvider";
import "./index.css";
import store from './redux/store';

ReactDOM.render(

  <ContextProvider>
    <Provider store={store}>
      <App />
    </Provider>
  </ContextProvider>
  ,

  document.getElementById("root")
);
